import { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Camera, Instagram, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CommunityGallery } from "@/components/CommunityGallery";
import { PhotoSubmitForm } from "@/components/PhotoSubmitForm";
import { BAR_NAME, INSTAGRAM_URL, INSTAGRAM_HANDLE, IMAGES } from "@/lib/config";

export default function FotoPage() {
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <div className="relative z-[2] min-h-[calc(100vh-68px)] overflow-hidden">
      <img src={IMAGES.hero} alt="" className="absolute inset-0 w-full h-full object-cover opacity-15" />
      <div className="absolute inset-0 bg-background/85" />

      <div className="relative z-10 max-w-5xl mx-auto px-5 sm:px-6 py-12 sm:py-16">
        <Link to="/" data-testid="foto-back" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-white transition-colors mb-8">
          <ArrowLeft className="w-4 h-4" /> Torna al sito
        </Link>

        <div className="text-center mb-12">
          <div className="flex items-center justify-center w-14 h-14 rounded-2xl bg-primary/15 ring-1 ring-primary/30 mx-auto mb-5">
            <Camera className="w-7 h-7 text-primary" />
          </div>
          <p className="font-mono text-xs tracking-[0.35em] text-primary mb-3">LA COMMUNITY DI {BAR_NAME}</p>
          <h1 className="font-serif text-5xl sm:text-6xl leading-[0.95] mb-4">Foto & Momenti</h1>
          <p className="text-lg text-muted-foreground max-w-xl mx-auto">
            I cocktail, i sorrisi e le serate di MI.RO'. Condividi la tua foto: le più belle finiscono qui e sui nostri canali.
          </p>
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="foto-instagram">
            <Button variant="outline" className="mt-6 rounded-full h-11 px-6 border-white/20 bg-white/5 hover:bg-white/10 text-white font-semibold">
              <Instagram className="w-4 h-4 mr-2" /> Seguici @{INSTAGRAM_HANDLE}
            </Button>
          </a>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <CommunityGallery refreshKey={refreshKey} />
          </div>
          <div className="lg:col-span-1">
            <div className="lg:sticky lg:top-24">
              <h2 className="font-serif text-2xl mb-4">Condividi la tua foto</h2>
              <PhotoSubmitForm onSubmitted={() => setRefreshKey((k) => k + 1)} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
